export default __webpack_public_path__ + "static/canopy_case_study_cover-9a4b220649719091fb84d8c8ec36b7ca.webp";